/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITileListItemViewProps } from './ext-tile-list-item';

/**
 *
 * ITileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
const renderTileListItemContent = (props: ITileListItemViewProps): JSX.Element => {
    const {
        heading,
        paragraph,
        backgroundImage,
        backgroundVideo,
        links,
        thumbnailImage,
        tileListContainer,
        tileListImageContainer,
        tileListThumbnailImageContainer,
        tileListHeadingContainer,
        hoverBackgroundVideo,
        hoverBackgroundImage,
        isMobileDevice
    } = props;

    return (
        <Node {...tileListContainer}>
            <Node className='ms-tile-list-media-hover'>{hoverBackgroundVideo || hoverBackgroundImage}</Node>
            <Node {...tileListImageContainer}>
                {isMobileDevice && hoverBackgroundVideo ? hoverBackgroundVideo : backgroundVideo || backgroundImage}
            </Node>
            <Node {...tileListHeadingContainer}>
                {heading}
                {paragraph}
                {links}
            </Node>
            <Node {...tileListThumbnailImageContainer}>{thumbnailImage}</Node>
        </Node>
    );
};

/**
 *
 * TileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
export const TileListItemViewComponent: React.FC<ITileListItemViewProps> = props => {
    const { tileListItem } = props;
    return <Module {...tileListItem}>{renderTileListItemContent(props)}</Module>;
};

export default TileListItemViewComponent;
